(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
(function (init) {
    var requiredElem = document.querySelectorAll('.fly-in');

    if (requiredElem.length) {
        init(requiredElem);
    }
}(function (flyInElems) {
    var debounce = require('lodash.debounce');
    var slightlyMoreThanAFrame = 17;
    var utils = require('./utils');
    var windowHeight;

    init();

    function init() {
        handleWindowResize();
        handleWindowScroll();
        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('scroll', debounce(handleWindowScroll, slightlyMoreThanAFrame));
    }

    function handleWindowResize() {
        windowHeight = window.innerHeight;
    }

    function handleWindowScroll() {
        utils.forEach(flyInElems, addClass);
    }

    function addClass(elem, index) {
        var elemRect = elem.getBoundingClientRect();
        var hasBeenScrolledPast = elemRect.top < -elemRect.height;
        var hasComeIntoView = elemRect.top < windowHeight;

        if (hasComeIntoView || hasBeenScrolledPast) {
            flyInElems[index].classList.add('fly-in--is-in-view');
        }
    }
}));

},{"./utils":4,"lodash.debounce":1}],3:[function(require,module,exports){
(function () {
    var styleElem = document.createElement('style');

    init();

    function init() {
        disallowOutline();
        document.getElementsByTagName('HEAD')[0].appendChild(styleElem);
        window.addEventListener('mousedown', disallowOutline);
        window.addEventListener('keydown', allowOutline);
    }

    function allowOutline(evt) {
        var wasTabKey = evt.which === 9;

        if (wasTabKey) {
            styleElem.textContent = '';
        }
    }

    function disallowOutline() {
        styleElem.textContent = ':focus{outline:0 !important}::-moz-focus-inner{border:0 !important;}';
    }
}());

},{}],4:[function(require,module,exports){
module.exports = (function () {
    function closest(element, selector) {
        while (element && element.nodeType === 1) {
            if (selectorMatches(element, selector)) {
                return element;
            }

            element = element.parentNode;
        }

        return null;
    }

    function selectorMatches(el, selector) {
        var p = Element.prototype;
        var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
            return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };
        return f.call(el, selector);
    }

    function forEach(object, callback) {
        var i;

        for (i = 0; i < object.length; i++) {
            callback(object[i], i);
        }
    }

    function getElemNaturalHeight(elem, doRecalc) {
        var currentHeight = elem.getBoundingClientRect().height;
        var naturalHeight;

        elem.style.height = 'auto';
        naturalHeight = elem.getBoundingClientRect().height;
        elem.style.height = currentHeight + 'px';

        if (doRecalc) {
            elem.getBoundingClientRect();
        }

        return naturalHeight + 'px';
    }

    function getSiteHeaderHeight() {
        return document.getElementById('site-header--js').getBoundingClientRect().height;
    }

    function preventDefault(evt) {
        evt.preventDefault();
    }

    function scrollTo(position) {
        var scrollDuration = 0.65;

        TweenLite.to(window, scrollDuration, {
            ease: Power2.easeOut,
            scrollTo: {
                y: position
            }
        });
    }

    function scrollToElement(elem) {
        var scrollDuration = 0.65;

        TweenLite.to(window, scrollDuration, {
            ease: Power2.easeOut,
            scrollTo: elem
        })
    }

    return {
        closest: closest,
        forEach: forEach,
        getElemNaturalHeight: getElemNaturalHeight,
        getSiteHeaderHeight: getSiteHeaderHeight,
        preventDefault: preventDefault,
        scrollTo: scrollTo,
        scrollToElement: scrollToElement
    };
}());

},{}],5:[function(require,module,exports){
module.exports = (function (init) {
    var requiredElem = document.querySelectorAll('.accordion__summary-button--js');

    if (requiredElem.length) {
        return init(requiredElem);
    }
}(function (summaryButtons) {
    var accordionClass = 'accordion--js';
    var accordionOpenClass = 'accordion--is-opened';
    var detailsElemClass = 'accordion__detail--js';
    var detailsElems = document.querySelectorAll('.accordion__detail--js');
    var iconCloseClass = 'icon-plus';
    var iconOpenClass = 'icon-minus';
    var utils = require('../auxilliary/utils');

    init();

    function init() {
        utils.forEach(summaryButtons, addSummaryEventListener);
        window.addEventListener('resize', handleWindowResize);
    }

    function addSummaryEventListener(summary) {
        summary.addEventListener('click', handleSummaryClick);
        initOpenedState(summary);
    }

    function initOpenedState(summary) {
        var parent = utils.closest(summary, '.' + accordionClass);
        var isAccordionOpen = parent.classList.contains(accordionOpenClass);

        if (isAccordionOpen) {
            openAccordion(parent);
        }
    }

    function handleWindowResize() {
        utils.forEach(detailsElems, updateDetailsHeight);

        function updateDetailsHeight(detailsElem) {
            var parent = utils.closest(detailsElem, '.' + accordionClass);

            if (parent.classList.contains(accordionOpenClass)) {
                detailsElem.style.height = utils.getElemNaturalHeight(detailsElem, true);
            }
        }
    }

    function toggleAll(accordionContainer, toggleClosed) {
        var accordions = accordionContainer.querySelectorAll('.' + accordionClass);

        utils.forEach(accordions, doToggle);

        function doToggle(accordion) {
            if (toggleClosed) {
                closeAccordion(accordion);
            } else {
                openAccordion(accordion);
            }
        }
    }

    function openAccordion(accordion) {
        var summaryElem = accordion.querySelector('.accordion__summary-icon--js');
        var detailsElem = accordion.querySelector('.' + detailsElemClass);

        accordion.classList.add(accordionOpenClass);
        detailsElem.style.height = utils.getElemNaturalHeight(detailsElem, true);
        summaryElem.classList.add(iconOpenClass);
        summaryElem.classList.remove(iconCloseClass);
    }

    function closeAccordion(accordion) {
        var summaryElem = accordion.querySelector('.accordion__summary-icon--js');

        accordion.classList.remove(accordionOpenClass);
        accordion.querySelector('.' + detailsElemClass).style.height = 0;
        summaryElem.classList.add(iconCloseClass);
        summaryElem.classList.remove(iconOpenClass);
    }

    function handleSummaryClick() {
        var parent = utils.closest(this, '.' + accordionClass);
        var isAccordionOpen = parent.classList.contains(accordionOpenClass);

        if (isAccordionOpen) {
            closeAccordion(parent);
        } else {
            openAccordion(parent);
        }
    }

    return {
        toggleAll: toggleAll
    };
}));

},{"../auxilliary/utils":4}],6:[function(require,module,exports){
module.exports = (function (init) {
    var requiredElem = document.getElementById('back-to-top--js');

    if (requiredElem) {
        return init(requiredElem);
    }
}(function (backToTopElem) {
    var utils = require('../auxilliary/utils');
    var scrollTo = utils.scrollTo;
    var visibleClass = 'back-to-top--is-visible';

    backToTopElem.addEventListener('click', scroll);

    function scroll(evt) {
        evt.preventDefault();
        scrollTo(0);
    }

    function hide() {
        backToTopElem.classList.remove(visibleClass);
    }

    function show() {
        backToTopElem.classList.add(visibleClass);
    }

    return {
        hide: hide,
        show: show
    };
}));

},{"../auxilliary/utils":4}],7:[function(require,module,exports){
(function (init) {
    var requiredElem = document.querySelectorAll('.detail-tabs-nav__anchor--js');

    if (requiredElem.length) {
        init(requiredElem);
    }
    window.saveState = true;
}(function (navAnchors) {
    var utils = require('../auxilliary/utils');
    var detailTabsNav = document.getElementById('detail-tabs-nav--js');
    var closeButton = document.getElementById('detail-tabs-nav__menu-close-button--js');
    var menuButton = document.getElementById('detail-tabs-nav__menu-button--js');

    init();

    function init() {
        closeButton.addEventListener('click', toggleMenu);
        menuButton.addEventListener('click', toggleMenu);
        utils.forEach(navAnchors, addTabNavEventListeners);
        checkHash(true);
    }

    function addTabNavEventListeners(anchor) {
        anchor.addEventListener('click', function (evt) {
            handleTabNavClick(evt, anchor)
        });
        anchor.addEventListener('click', toggleMenu);
    }

    function toggleMenu() {
        var desktopBreakpoint = 1023; // Keep this equal to $bp-desktop of _breakpoints.scss
        var navListContainer = document.getElementById('detail-tabs-nav__list-container--js');

        if (window.innerWidth > desktopBreakpoint) {
            return;
        }

        if (detailTabsNav.classList.toggle('detail-tabs-nav--is-active')) {
            navListContainer.style.height = utils.getElemNaturalHeight(navListContainer, true);
        } else {
            navListContainer.style.height = 0;
        }
    }
    function checkHash(){
        var url = window.location.href;
        var $links = $('.detail-tabs-nav').find('.detail-tabs-nav__anchor');

        if(url.indexOf('#') > -1){
            var hash = url.slice(url.indexOf('#') + 1);

            if(Number.isInteger(parseInt(hash))) {
                $links[0].click()
                //on pages that have buttons and also need to scroll to headers and have reader view grab the link by its href and select the second one to scroll to it on load
                setTimeout(() => {
                    $('.detail-tabs').animate({
                        scrollTop: document.querySelectorAll("a[href='#"+hash+"']")[1].offsetTop
                      }, 500);
                }, 500);
               
            }

            $links.each(function(){
                if($(this)[0].getAttribute('href') == '#' + hash){
                      var mq = window.matchMedia( "(max-width: 47.9375rem)")
                      var scrollToElement = document.getElementById('scroll-to')
                      if( mq.matches && scrollToElement){
                          var element = scrollToElement.getBoundingClientRect().top;
                          window.scrollTo({ top: element, behavior: "smooth"})
                      } else {
                          if (scrollToElement) scrollToElement.scrollIntoView();
                      }  
                     $(this)[0].click()
                    //  if (hashVals.length > 1){
                    //     //override browser anchor scroll
                    //     setTimeout(function() { window.scrollTo(0, 0);}, .5);
                    //  }
                }
            });
        }else if($links.length > 0){
            $links[0].click();
        }
    }

    function handleTabNavClick(evt, elem) {
        var anchorSelectedClass = 'detail-tabs-nav__anchor--is-selected';
        var selectedDetailTab = document.getElementById(elem.hash.slice(1));
        var detailTabs = document.querySelectorAll('.detail-tab--js');
        var tabSelectedClass = 'detail-tab--is-selected';
       // window.location.hash = selectedDetailTab.getAttribute('id')

        var url = window.location.href;
        if(url.indexOf('#') > -1){
            url = url.substring(0, url.indexOf('?'));
        }
        url = url + "#" + selectedDetailTab.getAttribute('id');
        var stateObj = window.state;
        if(stateObj == undefined){
            stateObj = {url: url};
        }
        evt.preventDefault();

        if(window.saveState)
            window.history.pushState(stateObj, "tabtitle", url);
        else
            window.saveState = true;

        utils.forEach(navAnchors, removeAnchorClasses); // 1
        utils.forEach(detailTabs, removeTabClasses); // 1
        selectedDetailTab.classList.add(tabSelectedClass); // 2
        utils.forEach(navAnchors, function(tab){
            if(tab.getAttribute('href') == '#' + selectedDetailTab.getAttribute('id')){
                tab.classList.add(anchorSelectedClass);
            }
        }); // 2

        function removeAnchorClasses(anchor) {
            anchor.classList.remove(anchorSelectedClass);
        }

        function removeTabClasses(tab) {
            tab.classList.remove(tabSelectedClass);
        }
    }

    window.onpopstate = function(event){
        window.saveState = false;
        checkHash();
    }
}));

},{"../auxilliary/utils":4}],8:[function(require,module,exports){
(function (init) {
  var requiredElem = document.querySelectorAll('.giant-v__scroll-indicator');

  if (requiredElem.length) {
      init(requiredElem);
  }
  window.saveState = true;
}(function (navAnchors) {
  var utils = require('../auxilliary/utils');

  init();

  function init() {
      var scrollIndicator = document.querySelectorAll('.giant-v__scroll-indicator')[0]
      scrollIndicator.addEventListener('click', function() {
        var scrollToElem = document.getElementById('scroll-to')
        if (scrollToElem) {
          utils.scrollTo(offset(scrollToElem).top - 100)
        }
      })
  }

  function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
}));

},{"../auxilliary/utils":4}],9:[function(require,module,exports){
(function (init) {
    var requiredElem = document.querySelectorAll('.email-disclaimer--js');

    if (requiredElem) {
        init(requiredElem);
    }
}(function (emailDisclaimer) {
    var emailControlPath = '/EmailDisclaimer/';
    var emailParams = '?emailprefix={0}&emaildomain={1}';
    var emailFrameParams = 'height=540,width=640,location=no,menubar=no,resizable=no,scrollbars=no,toolbar=no,status=no,left=100,top=100';
    var utils = require('../auxilliary/utils');

    init();

    function init() {
        utils.forEach(emailDisclaimer, processEmailDisclaimer);
    }

    function processEmailDisclaimer(disclaimer) {
        disclaimer.addEventListener('click', handleEmailLink);
    }

    function handleEmailLink() {
        var user = this.getAttribute('data-email-user');
        var domain = this.getAttribute('data-email-domain');
        if (user == null || user == '' || domain == null || domain == '') return;
        window.open(emailControlPath + emailParams.replace('{0}', user).replace('{1}', domain), '_blank', emailFrameParams, false);
    }
}));

},{"../auxilliary/utils":4}],10:[function(require,module,exports){
(function () {
  var requiredElem = $('.gallery-modal')
  if (requiredElem) {
    init(requiredElem)
  }
  function init (requireElem) {
    (function ($) {
      $.each(['show', 'hide'], function (i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function () {
          this.trigger(ev);
          return el.apply(this, arguments);
        };
      });
    })(jQuery);
    if (document.querySelector('.gallery-modal')) {
    $('.gallery-modal').on('show', function () {
        $('html').css({
          'overflow': 'hidden',
          'height': '100%',
          'position': 'fixed'
        })
      });
     $('.gallery-modal').on('hide', function () {
        $('html').css({
          'overflow': 'visible',
          'height': '',
          'position': ''
        })
      });
     document.querySelector('.gallery-modal').addEventListener('click', function (e) {
         if (e.target === this && $('.gallery-modal').css('display') !== 'none') {
             $('.gallery-modal').hide()
        }
      })
    }
  }
})()

},{}],11:[function(require,module,exports){
(function (init) {
  var requiredElem = $('.gallery')
  if (requiredElem) {
    init(requiredElem)
  }

  function init() {
    $('.gallery').on('click', function (event) {
      if (event.target === this) {
        $('.gallery-modal').hide()
      }
    })

    $('.gallery-button').on('click', function () {
      $('.gallery-modal').show()
      if (!$('.gallery.slick-initialized').length) {
        $('.gallery').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          centerMode: true,
          arrows: false,
          asNavFor: '.nav'
        })
        $('.nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.gallery',
          focusOnSelect: true,
          arrows: true,
          dots: false,
          centerMode: true,
          responsive: [{
            breakpoint: 2000,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
          ]
        })
      }
    })
  }
})()

},{}],12:[function(require,module,exports){
(function () {
  var requiredElem = $('.modal')
  if (requiredElem) {
    init(requiredElem)
  }
  function init (requireElem) {
    (function ($) {
      $.each(['show', 'hide'], function (i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function () {
          this.trigger(ev);
          return el.apply(this, arguments);
        };
      });
    })(jQuery);
    if (document.querySelector('.modal')) {
      $('.modal').on('show', function() {
        $('html').css({
          'overflow': 'hidden',
          'height': '100%'
        })
      });
      $('.modal').on('hide', function() {
        $('html').css({
          'overflow': 'visible',
          'height': ''
        })
      });
      var isAssociatePage = $('.careers-open-positions-btn')[0]
      var isShareholderPage = $('#privacy-policy-link')[0]

      if (!(isAssociatePage || isShareholderPage)) {

        document.querySelector('.modal').addEventListener('click', function (e) {
          if (e.target === this && $('.modal').css('display') !== 'none') {
            $('.modal').hide()
          }
        })

      }
      else {
        const ASSOCIATE_KEY = 'privacy-policy-associate'
        const SHAREHOLDER_KEY = 'privacy-policy-shareholder'

        const getCookie = (key) => (document.cookie.split(';')
          .find(cookie => cookie.trim().startsWith(key + '=')) || '')
          .trim()

        const setCookie = (key, value) => {
          const d = new Date()
          d.setDate(new Date().getDate() + 1)
          d.setHours(0, 0, 0, 0)
          const midnight = d.toUTCString()
          document.cookie = `${key}=${value}; expires=${midnight}; path=/`
        }

        function openModal() {
          $('.modal.privacy-policy').css('display', 'flex')
          $('.modal__background').show();
          $('.standard-panel__decoration-container.standard-panel__decoration-container--careers-detail').css('z-index', '0')
          $('html, body').css({
            overflow: 'hidden',
            height: '100%'
          });
          $('.modal__privacy-policy-checkbox').prop('checked', false)
          $('.modal__submit-btn').prop('disabled', 'disabled')
        }

        function closeModal() {
          $('.modal.privacy-policy').hide()
          $('.modal__background').hide()
          $('html, body').css({
            overflow: 'auto',
            height: 'auto'
          });
        }

        if (isAssociatePage) {
          document.querySelector('.careers-open-positions-btn').addEventListener('click', function (e) {
            if (getCookie(ASSOCIATE_KEY)) {
              window.open($('.modal__submit-btn').data('vi-desktop-link'), '_blank')
            }
            else {
              openModal()
            }
          })
        }
        if (isShareholderPage) {
          document.getElementById('privacy-policy-link').addEventListener('click', function (e) {
            e.preventDefault()
            if (getCookie(SHAREHOLDER_KEY)) {
              window.open($('.modal__submit-btn').data('vi-desktop-link'), '_blank')
            }
            else {
              openModal()
            }
          })
        }

        document.querySelector('.modal__close-btn').addEventListener('click', function (e) {
          closeModal()
        })

        document.querySelector('.modal__background').addEventListener('click', function (e) {
          closeModal()
        })

        document.querySelector('.modal__privacy-policy-checkbox').addEventListener('change', function (e) {
          if (this.checked) {
            $('.modal__submit-btn').removeAttr('disabled')
          }
          else {
            $('.modal__submit-btn').prop('disabled', 'disabled')
          }
        });

        document.querySelector('.modal__submit-btn').addEventListener('click', function (e) {
          if (isAssociatePage) {
            window.open($(e.target).data('vi-desktop-link'), '_blank')
            setCookie(ASSOCIATE_KEY, 1)
          }
          else if (isShareholderPage) {
            window.open($(e.target).data('vi-desktop-link'), '_blank')
            setCookie(SHAREHOLDER_KEY, 1)
          }
          closeModal()
        })
      }
    }
  }
})()

},{}],13:[function(require,module,exports){
(function (init) {
  var requiredElem = document.querySelector('.js-professional-readmore');

  if (requiredElem) {
      init(requiredElem);
  }
  window.saveState = true;
}(function (professionalGrid) {
  var gridItemClass = '.professional-grid__item'
  var showMoreButton = '.js-read-more-button'
  
  init()

  function init() {
    const $professionalGridItems = $(professionalGrid).find(gridItemClass)

    if ($professionalGridItems.length >= 6) {
      handleToggle($professionalGridItems)
    }
  }

  function handleToggle($gridItems) {
    var $toggleButton = $(showMoreButton)
    var $itemsToToggle = $gridItems.slice(6)
    var isShown = false
    
    $itemsToToggle.slideUp()

    $toggleButton.on('click', function(ev) {
      ev.preventDefault()
      if (isShown) {
        $itemsToToggle.slideUp()
        $toggleButton.text('View More +')
      } else {
        $itemsToToggle.slideDown()
        $toggleButton.text('View Less -')
      }
      isShown = !isShown
      
    })

  }
}));

},{}],14:[function(require,module,exports){
(function () {
  if (document.querySelector('.reader-view')) {
    document.querySelector('.reader-view').addEventListener('click', function () {
      if ($('.modal').css('display') === 'none') {
        $('.modal').show()
      }
    })
    document.querySelector('.reader-modal__close__icon-close').addEventListener('click', function () {
      if ($('.modal').css('display') !== 'none') {
        $('.modal').hide()
      }
    })
  }
})()

},{}],15:[function(require,module,exports){
(function (init) {
    var requiredElem = document.getElementById('services-grid--js');

    if (requiredElem) {
        init(requiredElem);
    }
}(function (servicesGrid) {
    var accordionModule = require('../components/accordion');
    if (accordionModule != null)
    {
        var toggleAccordions = accordionModule.toggleAll;
    }

    var viewAllButton = document.getElementById('services-grid__view-all-button--js');
    var viewAllButtonActiveClass = 'services-grid__view-all-button--is-active';
    var textActive = viewAllButton.querySelector('.services_button_span-open');
    var textInactive = viewAllButton.querySelector('.services_button_span-close');
    var textActiveClass = 'services_button_span--active';

    viewAllButton.addEventListener('click', handleViewAllClick);

    function handleViewAllClick() {
        var viewAllButtonClassList = viewAllButton.querySelector('.services_arrow_button_span').classList
        if (viewAllButtonClassList.contains('icon-plus')){
            viewAllButtonClassList.remove('icon-plus')
            viewAllButtonClassList.add('icon-minus')
        }
        else {
            viewAllButtonClassList.remove('icon-minus')
            viewAllButtonClassList.add('icon-plus')
        }
        viewAllButton.querySelector('.services_arrow_button_span').classList.toggle('arrow-button--is-active');

        if (toggleAccordions != null)
        {
            toggleAccordions(servicesGrid, viewAllButton.classList.contains(viewAllButtonActiveClass)); // 1
        }
        viewAllButton.classList.toggle(viewAllButtonActiveClass); // 2
        if (textActive && textInactive) {
            textActive.classList.toggle(textActiveClass);
            textInactive.classList.toggle(textActiveClass);
        }
    }
}));

},{"../components/accordion":5}],16:[function(require,module,exports){
(function () {
    'use strict';

    // Auxilliary
    require('./auxilliary/fly-in');
    require('./auxilliary/toggle-focus-outline');

    // Components
    require('./components/accordion');
    require('./components/detail-tabs');
    require('./components/services-grid');
    require('./components/email-disclaimer');
    require('./components/reader-view');
    require('./components/gallery');
    require('./components/modal');
    require('./components/gallery-modal');
    require('./components/down-arrow-scroll')
    require('./components/professional-grid')

    // Modules
    require('./modules/standard-panel-nav');
    //require('./modules/services-landing-content');
    //require('./modules/vedder-thinking-nav');

    // Structures
    require('./structures/site-header');
}());

},{"./auxilliary/fly-in":2,"./auxilliary/toggle-focus-outline":3,"./components/accordion":5,"./components/detail-tabs":7,"./components/down-arrow-scroll":8,"./components/email-disclaimer":9,"./components/gallery":11,"./components/gallery-modal":10,"./components/modal":12,"./components/professional-grid":13,"./components/reader-view":14,"./components/services-grid":15,"./modules/standard-panel-nav":17,"./structures/site-header":18}],17:[function(require,module,exports){
(function (init) {
    var requiredElem = document.querySelector('.standard-panel-nav--js');

    if (requiredElem) {
        init();
    }
}(function () {
    var backToTop = require('../components/back-to-top');
    var debounce = require('lodash.debounce');
    var panelCoords;
    var panels = document.querySelectorAll('.standard-panel--js');
    var utils = require('../auxilliary/utils');
    var scrollTo = utils.scrollTo;
    var siteHeaderHeight = utils.getSiteHeaderHeight();

    addEventListeners();
    setPanelCoords();

    function addEventListeners() {
        var slightlyMoreThanAFrame = 17;

        document.body.addEventListener('click', handleAnchorClick);
        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('scroll', debounce(handleScroll, slightlyMoreThanAFrame));
    }

    function handleAnchorClick(evt) {
        var anchorClass = 'standard-panel-nav__anchor--js';
        var clickedElem = evt.target;
        var panel;

        if (clickedElem.classList.contains(anchorClass)) {
            evt.preventDefault();
            panel = document.getElementById(clickedElem.hash.slice(1));
            scrollTo(panel.getBoundingClientRect().top + pageYOffset - siteHeaderHeight);
        }
    }

    function handleScroll() {
        var scrollY = pageYOffset;
        var currentPanelIndex = getCurrentPanelIndex();

        updateActiveAnchors('#' + panels[currentPanelIndex].id);

        if (currentPanelIndex > 0) {
            backToTop.show();
        } else {
            backToTop.hide();
        }

        function getCurrentPanelIndex() {
            var currentPanelIndex = 0;
            var i;

            for (i = 0; i < panelCoords.length; i++) {
                if (scrollY >= panelCoords[i].docPos - panelCoords[i].height / 2) {
                    currentPanelIndex = i;
                }
            }

            return currentPanelIndex;
        }
    }

    function handleWindowResize() {
        setPanelCoords();
        handleScroll();
    }

    function setPanelCoords() {
        var scrollY = pageYOffset;

        panelCoords = [];
        utils.forEach(panels, pushPosition);

        function pushPosition(panel) {
            var clientRect = panel.getBoundingClientRect();
            var coords = {};

            coords.docPos = clientRect.top + scrollY;
            coords.height = clientRect.height;
            panelCoords.push(coords);
        }
    }

    function updateActiveAnchors(activeHash) {
        var anchors = document.querySelectorAll('.standard-panel-nav__anchor--js');
        var anchorActiveClass = 'standard-panel-nav__anchor--is-active';

        utils.forEach(anchors, update);

        function update(anchor) {
            anchor.classList.remove(anchorActiveClass);

            if (activeHash === anchor.hash) {
                anchor.classList.add(anchorActiveClass);
            }
        }
    }
}));

},{"../auxilliary/utils":4,"../components/back-to-top":6,"lodash.debounce":1}],18:[function(require,module,exports){
(function (init) {
    var requiredElem = document.getElementById('site-header--js');

    if (requiredElem) {
        init(requiredElem);
    }
}(function (siteHeader) {
    var drawer = document.getElementById('site-header-drawer--js');
    var drawerActiveClass = 'site-header-drawer--is-active';
    var drawerToggleActiveClass = 'site-header__drawer-toggle--is-active';
    var isDrawerOpen = false;
    var mutationObserver = new MutationObserver(setDrawerHeight);
    var mutationConfig = {
        childList: true,
        subtree: true
    };
    var siteSearchResults = document.getElementById('site-search__results--js');
    var utils = require('../auxilliary/utils');

    init();

    function init() {
        //mutationObserver.observe(siteSearchResults, mutationConfig);
        var drawerToggleNavLinks = siteHeader.querySelectorAll('.site-header__drawer-toggle--js');
        utils.forEach(drawerToggleNavLinks, function (e) {
            e.addEventListener('click', handleNavClick);
        });
        window.addEventListener('resize', handleWindowResize);
        $('.site-search__search-input').focus();
    }
    function toggleDrawerActiveClass() {
        
        drawer.classList.toggle(drawerActiveClass);
    }

    function closeDrawer() {
        drawer.classList.remove(drawerActiveClass);
        isDrawerOpen = false;
        drawer.style.height = 0;
    }

    function setDrawerHeight() {
        drawer.style.height = utils.getElemNaturalHeight(drawer, true);
    }

    function handleWindowResize() {
        if (isDrawerOpen) {
            setDrawerHeight();
        }
    }

    function openDrawer(wasSearchButtonClicked, wasShareToolsClicked) {
        requestAnimationFrame(doOpen);
        drawer.classList.add(drawerActiveClass);
        isDrawerOpen = true;

        function doOpen() {
            
            updateClasses(wasSearchButtonClicked, wasShareToolsClicked);
            setDrawerHeight();
            $('.site-search__search-input').focus();
        }
    }

    function isMenuLinkActive(el) {
        return el.classList.contains(drawerToggleActiveClass);
    }

    function handleNavClick() {
        var self = this;
        var shouldDrawerOpen = updateNavActiveState(self);

        var wasSearchButtonClicked = self.classList.contains('site-header__search-button--js');
        var wasShareToolsClicked = self.classList.contains('site-header__share-tools')

        if (shouldDrawerOpen) {
            openDrawer(wasSearchButtonClicked, wasShareToolsClicked);
            window.addEventListener('touchmove', utils.preventDefault);
        } else {
            requestAnimationFrame(closeDrawer);
            window.removeEventListener('touchmove', utils.preventDefault);
        }
    }

    function updateNavActiveState(el) {
        var activeLink = siteHeader.querySelector('.' + drawerToggleActiveClass);

        //drawer is closed toggle this element to active
        //return true to open drawer
        if (!isDrawerOpen) {
            el.classList.add(drawerToggleActiveClass);
            return true;
        }
        else { //drawer is open
            //if link is already active remove state
            //return false to close drawer
            if (isMenuLinkActive(el)) {
                el.classList.remove(drawerToggleActiveClass);
                return false;
            }
            else {
                //keep drawer open
                //remove active state from active link and set clicked link to active
                activeLink.classList.remove(drawerToggleActiveClass);
                el.classList.add(drawerToggleActiveClass);
                return true;
            }
        }

    }

    function updateClasses(wasSearchButtonClicked, wasShareToolsClicked) {
        var siteNav = document.getElementById('site-nav--js');
        var siteNavActiveClass = 'site-nav--is-active';
        var siteSearch = document.getElementById('site-search--js');
        var siteSearchActiveClass = 'site-search--is-active';
        var shareTools = document.getElementById('share-tools--js')
        var shareToolsActiveClass = 'site-header__mini-tool-list--is-active'

        siteNav.classList.remove(siteNavActiveClass);
        siteSearch.classList.remove(siteSearchActiveClass);
        shareTools.classList.remove(shareToolsActiveClass)

        if (wasSearchButtonClicked) {
            siteSearch.classList.add(siteSearchActiveClass);
        } else if (wasShareToolsClicked) {
            shareTools.classList.add(shareToolsActiveClass)
        } else {
            siteNav.classList.add(siteNavActiveClass);
        }
    }
}));

},{"../auxilliary/utils":4}]},{},[16]);
